import React, {useCallback, useLayoutEffect, useRef, useState} from 'react'
import {findDOMNode} from "react-dom"

import HintPopover from "../../../../../../core/gd-ui/hint-popover/hint-popover"
import AddViewPopover from "../../../../../../core/gd-ui/add-view/add-view-popover"
import getNewProjectViewItemsGrouped from "./popover/functions/get-add-project-view-config"
import {PopoverAttachmentType} from "../../../../../../core/gd-components/gd-popover/@const"
import addView_checkConvertRequirementAndConfirm from "./popover/functions/check-and-confirm-page-convert"
import StartPopover from "../../../../../../core/gd-ui/start-popover/start-popover"
import {ViewType} from "../../../../../../core/gd/const/views/view-type"

export const SHOW_ADD_VIEW_POPOVER = 'show-add-view-popover'

type Props = {
    className?          : string

    projectId           : ID
    selectedGroupId?    : ID

    onTogglePopover?    : {(value:boolean):void}
}

export default function AddView(props: Props) {

    const selfRef:any                   = useRef()
    const [showPopover, setShowPopover] = useState(false)

    const onShowPopover = useCallback((e?:any) => {
        if (e) e.stopPropagation()

        const process = async () => {
            const result = await addView_checkConvertRequirementAndConfirm(props.projectId)

            switch (result) {
                case "continue":
                    setShowPopover(true)
                    props.onTogglePopover && props.onTogglePopover(true)
                    break
            }
        }

        process()
    }, [])

    useLayoutEffect(() => {
        return gd.bus.subscribeNoContext(SHOW_ADD_VIEW_POPOVER, onShowPopover)
    }, []);

    const hidePopover = useCallback((e?:any) => {
        if (e) e.stopPropagation()

        setShowPopover(false)
        props.onTogglePopover && props.onTogglePopover(false)
    }, [])

    const classes = Classes(props.className, {
        'show-popover': showPopover
    })

    const buttonClasses = Classes("project-add-view ui5-control-button s-28 i5-plus fs-14 ui5-color-not-important", {
        'show-popover': showPopover
    })

    const viewsStructure    = getNewProjectViewItemsGrouped(props.projectId)

    const showArrowHint     = gd.projectViews.project.isWorkspace && gd.projectViews.currentView.type === ViewType.PROJECT_EVERYTHING

    return (
        <div ref        = {selfRef}
             className  = {classes}
             onClick    = {onShowPopover}
        >
            <div className={buttonClasses}/>
            {showPopover &&
                <AddViewPopover
                    viewsStructure      = {viewsStructure}
                    selectedGroupId     = {props.selectedGroupId}
                    offset              = "0 6"
                    attachment          = "top left"
                    targetAttachment    = "bottom left"
                    attachmentType      = {PopoverAttachmentType.HORIZONTAL}
                    getTargetFunc       = {()=>findDOMNode(selfRef.current)}
                    hidePopover         = {hidePopover}
                />}

            {!showPopover &&
                <HintPopover hint="Add view"/>}

            {showArrowHint &&
                <StartPopover message="Start by adding a new view"/>}
        </div>
    )
}
